import { apiRequest, incaAccessor } from '@cancercentrum/inca';
import uniq from 'lodash/uniq';
import without from 'lodash/without';
import orderBy from 'lodash/orderBy';
import { DEFAULT_TAG_SORTORDER, LOCKED_SYSTEM_TAGS } from './constants';
const getPayload = (row, ctx, changedErrandProps)=>{
    const inca = incaAccessor();
    const json = {
        ...ctx.errand,
        contributingPositionIds: [],
        obliterateReason: '',
        internalInformation: inca.errand?.internalInformation ?? '',
        data: row.toIncaJS()
    };
    Object.entries(changedErrandProps ?? {}).forEach(([key, val])=>{
        if (val !== undefined) {
            json[key] = val;
        }
    });
    return json;
};
const getExistingTags = (ctx)=>{
    return (ctx.errand.errandTags || '').split(';').filter((x)=>x);
};
export const errandButtonUtils = {
    performStateTransition: async (transitionName, ctx, api, changedErrandProps)=>{
        const inca = incaAccessor();
        const initialRow = ctx.store.getState().data.present;
        const shouldContinue = await api.events.onBeforeExecuteErrand.trigger(()=>[
                transitionName,
                initialRow,
                ctx.store.getState().data.present,
                getPayload(initialRow, ctx, changedErrandProps),
                ctx
            ], Promise.resolve(true));
        if (!shouldContinue) {
            return null;
        }
        const row = ctx.store.getState().data.present; // row could have been updated in event handler
        inca.form.data = row.toIncaJS();
        const payload = getPayload(row, ctx, changedErrandProps);
        const res = await apiRequest(`/Errands/${ctx.errand.id}/Event/ShortName/${transitionName}/Execute`, {
            method: 'PUT',
            json: payload
        });
        try {
            await api.events.onAfterExecuteErrand.trigger(()=>[
                    transitionName,
                    row,
                    res,
                    payload,
                    ctx
                ], Promise.resolve());
        } catch (ex) {
            return [
                res,
                ex
            ];
        } finally{
            inca.overview.refreshOverviewBoxes();
        }
        return [
            res,
            null
        ];
    },
    getExistingTags: getExistingTags,
    getSelectableTags: (buttonSpecificTags, tagsToRemove, ctx)=>{
        const inca = incaAccessor();
        if (inca.user.role.isReviewer) {
            const existingTags = getExistingTags(ctx);
            return uniq([
                ...without(existingTags, ...[
                    ...LOCKED_SYSTEM_TAGS,
                    ...tagsToRemove
                ]),
                ...buttonSpecificTags
            ]);
        }
        return buttonSpecificTags.filter((x)=>x);
    },
    getInitiallySelectedTags: (selectableTags, ctx)=>{
        const existingTags = getExistingTags(ctx);
        return selectableTags.filter((x)=>existingTags.includes(x));
    },
    getTagsString: (selectedTags, selectableTabs, tagsToRemove, ctx, tagSortOrder = DEFAULT_TAG_SORTORDER)=>{
        const existingTags = getExistingTags(ctx);
        const newTags = uniq([
            ...without(existingTags, ...[
                ...selectableTabs,
                ...tagsToRemove
            ]),
            ...selectedTags
        ]).filter((x)=>x);
        return orderBy(newTags.filter((x)=>x), [
            (x)=>!tagSortOrder.includes(x),
            (x)=>tagSortOrder.indexOf(x),
            (x)=>x
        ]).join(';');
    }
};
